import { createAPI } from '@common'

export default {
  // 新建活动
  postActivity: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz', 'post', config),
    //入选
  postActivityEntryMark: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0fousz0nbsl', 'post', config),
  //查询活动权限接口
  getActivityActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0benjo0qfsnjttjpot0bdujpot0ojtDbu', 'get', config),
  //保存活动权限接口
  postActivityActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0benjo0qfsnjttjpot0bdujpot0ojt', 'post', config),
  //取消入选
  postActivityEntryCancleMark: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0fousz0dbodmfNbsl', 'post', config),
  // 修改活动报名信息
  postActivityEntryUpdate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0fousz0vqebuf', 'post', config),
  //查询系统当前的主题色作为表单征集活动按钮默认颜色配置
  getAppMainColor: (config) =>    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0bqqNbjoDpmps', 'GET', config),
  //公布名单
  postActivityEntryShow: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0fouszTipx', 'post', config),

  //取消公布
  postActivityEntryClose: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0fouszDmptf', 'post', config),

  getFolderUsedByCols: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0difdlGpmefsVtfe', 'get', config, {
      neverLoading: true
    }),
  getActivityDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0efubjm', 'get', config),
  getActivityEntryDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0fousz0efubjm', 'get', config),
  // 校验文件夹是否被稿件引用
  getActivityCheckFolderUsed: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0difdlGpmefsVtfe', 'get', config),

  postActivityCheckUsed: (config) =>
  createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0difdlVtfe', 'post', config),
  // 新增文件夹
  postFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0f60benjo0epn0gpmefst', 'post', config),
  // 修改文件夹
  putFolder: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0f60benjo0epn0gpmefst', 'post', config),
  // 删除文件夹
  deleteFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0f60benjo0epn0gpmefst', 'delete', config),
  // 删除文件夹
  getFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0f60benjo0epn0gpmefs', 'get', config),

  getRootFunc: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0f60gpmefst0sppu', 'get', config),
  getSubsFunc: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0f60gpmefst', 'get', config),
  // 新建 - 保存
  postNisActivity: config => createAPI('customEncryptApiName-1/0w20ojt0bdujwjuz', 'POST', config),
  // 修改 - 保存
  putNisActivity: config => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz', 'PUT', config),
  // 获取活动
  getNisActivity: config => createAPI('customEncryptApiName-1/0w20ojt0bdujwjuz', 'GET', config),
  // 删除 活动
  postNisActivityDelete: config => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0efmfuf', 'POST', config),
  // 删除前状态检查
  getNisActivityDeleteStatus: config => createAPI('customEncryptApiName-1/0w20ojt0bdujwjuz0efmfuf0tubuvt', 'GET', config),
  getGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut', 'get', config),
  postGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut', 'post', config),
  putGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut', 'put', config),
  deleteGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut0efmfuf', 'post', config),
  //获取分组详情
  getGroupsDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut0efubjm', 'get', config),
  postActivityEntryExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0fousz0fyqpsu', 'post', config),
  postActivityDrag: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut0esbh', 'post', config),
  // 撤回 和发布
  postActivityPubOrRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0qvcPsSfwplf', 'post', config),
  //预览社圈
  postNisActivityPreview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0qsfwjfx', 'post', config),
  // 公布名单时对入选用户，消息通知设置
  postNisActivityNotificationConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0dpogjh', 'post', config),
  // 公布名单时对入选用户，获取消息通知设置
  getNisActivityNotificationConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0dpogjh', 'get', config),

}
